import { SITE_PRIVACY_POLICY_URL, SITE_TERMS_OF_USE_URL } from '~/constants';
import { paymentAgreementSidekicker } from '~/projects/sidekicker/config/agreementCopy';
import { ProjectRuntimeBehavior } from '~/projects/types';

const runtimeBehavior: ProjectRuntimeBehavior = {
  title: 'Sidekicker AI',
  fetchSubscriptionEndpoint: true,
  createFunnelUserBeforeSignUp: false,
  fetchTrustpilotInviteUrl: true,
  subscriptionFromProfileOnly: false,
  showSubscriptionUsageBlocks: true,
  withOnboardingMiddleware: true,
  settingsMainLayoutNoSidebar: false,
  loadDesktopSidebarThemeToggle: false,
  chatVendorDefaultIsGpt51: false,
  chatVendorSelectorAvailableWithoutFeatureFlag: false,
  chatUsesGptShellLayout: false,
  chatAnonymousSessionsEnabled: false,
  chatUsesChatwithaiEndpoints: false,
  showFrozenSubscriptionBlock: true,
  showHomeRetentionPopover: true,
  showTrustpilotMentions: true,
  openTrustpilotOnChatLike: true,
  backendErrorsHandlingStrategy: 'default',
  signUpUsesDeviceIdHeader: false,
  showNoActiveSubscriptionModal: true,
  paymentConfigByRegion: {
    default: { getCompanyAddress: paymentAgreementSidekicker },
  },
  personalInformationLegalLinksByRegion: {
    default: [],
    US: [
      { label: 'Terms of Service', href: SITE_TERMS_OF_USE_URL },
      { label: 'Privacy Policy', href: SITE_PRIVACY_POLICY_URL },
    ],
  },
};

export default runtimeBehavior;
